import { render, staticRenderFns } from "./D2COMD0050.vue?vue&type=template&id=2a8fdf57&scoped=true&"
import script from "./D2COMD0050.vue?vue&type=script&lang=js&"
export * from "./D2COMD0050.vue?vue&type=script&lang=js&"
import style0 from "./D2COMD0050.vue?vue&type=style&index=0&id=2a8fdf57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fdf57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VIcon,VImg,VRow})
